import { byNewestRule, ruleMatchesQuery } from '@/function/begateway/rule.query';
import { begatewayAccessApi } from '@/store/api/begateway/begateway.access.api';
import type { TypeAppDispatch, TypeRootState } from '@/store/store';
import type { TypeAccessRule } from '@/types/begateway/types.begateway.access';

export const writeAccessRule = (dispatch: TypeAppDispatch, rule: TypeAccessRule) => {
    dispatch((inner: TypeAppDispatch, getState: () => TypeRootState) => {
        for (const args of begatewayAccessApi.util.selectCachedArgsForQuery(getState(), 'listAccessRules')) {
            inner(begatewayAccessApi.util.updateQueryData('listAccessRules', args, (draft) => {
                const index = draft.items.findIndex((entry) => entry.id === rule.id);
                const belongs = ruleMatchesQuery(rule, args);
                if (index >= 0 && belongs) draft.items[index] = rule;
                else if (index >= 0) draft.items.splice(index, 1);
                else if (belongs) {
                    draft.items.push(rule);
                    draft.items.sort(byNewestRule);
                }
            }));
        }
        inner(begatewayAccessApi.util.updateQueryData('readAccessRule', rule.id, () => rule));
    });
};
